import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=66a87a5c&"
import script from "./LoginPage.vue?vue&type=script&lang=js&"
export * from "./LoginPage.vue?vue&type=script&lang=js&"
import style0 from "./LoginPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports